module.exports = __webpack_public_path__ + "static/media/rundkolben_schema.d79cfe65.jpg";